(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pjs-card-size-quick-add"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pjs-card-size-quick-add')) {
    customElements.define(
      'pjs-card-size-quick-add',
      class PjsCardSizeQuickAdd extends HTMLElement {
        connectedCallback() {
          if (this.dataset.initialized === 'true') return;

          this.dataset.initialized = 'true';
          this.variantInput = this.querySelector('[data-pjs-selected-variant]');
          this.submitButton = this.querySelector('[type="submit"]');
          this.productForm = this.querySelector('product-form');
          this.normalLabel = this.querySelector('[data-pjs-add-label]');
          this.soldOutLabel = this.querySelector('.sold-out-message');
          this.errorWrapper = this.querySelector('.product-form__error-message-wrapper');
          this.addEventListener('change', this.handleVariantChange.bind(this));
        }

        handleVariantChange(event) {
          const radio = event.target.closest('[data-pjs-variant-id]');
          if (!radio || radio.disabled || !this.variantInput || !this.submitButton) return;

          this.variantInput.value = radio.dataset.pjsVariantId;

          if (!this.submitButton.classList.contains('loading')) {
            this.submitButton.disabled = false;
            this.submitButton.removeAttribute('aria-disabled');
          }

          if (this.normalLabel) {
            this.normalLabel.textContent = this.normalLabel.dataset.pjsAddToCartLabel;
            this.normalLabel.classList.remove('hidden');
          }
          this.submitButton.setAttribute(
            'aria-label',
            `${this.normalLabel?.dataset.pjsAddToCartLabel || 'Add to cart'}: ${this.submitButton.dataset.pjsProductTitle || ''}`
          );
          if (this.soldOutLabel) this.soldOutLabel.classList.add('hidden');
          if (this.errorWrapper) this.errorWrapper.hidden = true;

          if (this.productForm) {
            this.productForm.error = false;
            if (typeof this.productForm.handleErrorMessage === 'function') {
              this.productForm.handleErrorMessage();
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
